let betbyKillHandler: (() => void) | null = null;

export function registerBetbyKillHandler(handler: (() => void) | null): void {
  betbyKillHandler = handler;
}

export function executeBetbyKill(): void {
  if (typeof betbyKillHandler === "function") {
    betbyKillHandler();
  }
}
